import { ExtendedUserField, GroupField } from 'components';
import { ReactElement } from 'react';
import { LazyAgencyQuotaAlert } from 'modules/core/hub/lazy';
import { useField } from 'react-final-form';
import { UserOrInvite } from './UserOrInvite';
import { useSessionScope } from 'services';

interface MembershipFormProps {
  enterpriseId?: number;
}

export function Form({ enterpriseId: explicitEnterpriseId }: MembershipFormProps = {}): ReactElement {
  const {
    input: { value: id },
  } = useField('id', { subscription: { value: true } });

  // This component is used both in Preferences -> Membership and System -> Agencies -> {Agency} -> Membership. And the
  // latter maybe be accessed under AGENCY_GROUP scope.
  const sessionScope = useSessionScope();
  const enterpriseId = explicitEnterpriseId ?? ('id' in sessionScope ? sessionScope.id : undefined);

  return (
    <div className="row">
      <div className="col-md-6">
        {!id && enterpriseId && <LazyAgencyQuotaAlert enterpriseId={enterpriseId} />}
        {id ? <ExtendedUserField name="user" placeholder="User" required disabled /> : <UserOrInvite />}
        <GroupField name="groups" label="Roles" required isMulti help="Type to find a specific agency role" />
      </div>
    </div>
  );
}
